export function setPublicationStatus(state, info){
  state.mode = info.mode,
  state.publicationId = info.id;
}